import { CartService, CartServiceModule } from '@b2b/common/services';
import angular from 'angular';
import { OrderContactDirectiveModule } from '../order/contact/contact.directive';
import { OrderCouponsDirectiveModule } from '../order/coupons/coupons.directive';
import { OrderOrganizationDirectiveModule } from '../order/organization/organization.directive';
import { OrderSummaryDirectiveModule } from '../order/summary/summary.directive';

function CartDirective() {
  CartDirectiveController.$inject = [
    '$q',
    '$scope',
    '$state',
    '$timeout',
    '$uibModal',
    'ApiService',
    'OrderService',
    'CartService',
  ];

  function CartDirectiveController(
    $q,
    $scope,
    $state,
    $timeout,
    $uibModal,
    ApiService,
    OrderService,
    CartService: CartService
  ) {
    const ctrl = this;
    ctrl.showCoupons = false;

    $scope.cart = {
      model: {},
      summary: {},
      memberships: [],
      events: [],
      coupons: [],
      orderContact: {},
      organization: {},
      cartService: CartService,
      hasItems: false,
      cancelModal: {},
      allowEventSales: true,

      tab: 'individual',

      init: function () {
        $scope.$watch('cart.cartService.itemCount', this.onCartServiceItemCountUpdate);
        $scope.$watch('cart.cartService.orderContact', angular.bind(this, this.refresh));
        $scope.$watch('cart.cartService.organization', this.onCartServiceOrganizationUpdate);
        $scope.$watch('cart.cartService.events.events.length', angular.bind(this, this.refresh));
        $scope.$watch('showCoupons', angular.bind(this, this.setShowCoupon));
        $scope.$watchCollection(
          'cart.cartService.transactingMember',
          angular.bind(this, this.updateOrderContactMembership)
        );
        $scope.$on('OrderItem::Remove', angular.bind(this, this.refresh));
        //If the selected offer changes for a membership even when orderContact is not updated
        $scope.$watch('cart.cartService.memberships.model', angular.bind(this, this.refresh));
      },

      setShowCoupon: function (newValue, oldValue) {
        ctrl.showCoupons = newValue;
      },

      refresh: function () {
        this.summary = CartService.getSummary();
        this.memberships = CartService.memberships.getModel();
        this.events = CartService.events.getEvents();
        this.orderContact = CartService.getOrderContact();
        this.updateOrderContactMembership();
      },

      updateOrderContactMembership: function () {
        if (this.orderContact) {
          this.orderContact.membership = this.cartService.getTransactingMembership();
        }
      },

      viewCart: function () {
        $state.go('application.cart');
        $scope.$emit('Cart::Close');
      },

      getPricesForEvent: function (event) {
        const eventPrices = event.event && event.event.priceList.prices ? event.event.priceList.prices : [];

        return eventPrices;
      },

      getAddOnsForEvent: function (event) {
        const eventAddOns = event.event && event.event.addOns ? event.event.addOns.inventoryAddOns : [];

        return eventAddOns;
      },

      launchOrganizationOrder: function (e, data) {
        //copy organization, events and quantities to the old organization checkout flow
        //cancel the cart
        const self = $scope.cart;
        const orgOrder = self.cartService.events.getOrganizationOrder();

        OrderService.init();
        OrderService.clear();
        OrderService.store({
          cart: {
            events: orgOrder.events,
          },
        });

        self.cartService.cancelCart();

        $scope.$emit('Cart::Close');

        $state.go('application.orders.checkout', { accountId: orgOrder.organizationId });
      },

      cancel: function () {
        const self = $scope.cart;

        self.cancelModal = $uibModal.open({
          size: 'md',
          controller: 'ConfirmModalController',
          templateUrl: 'common/views/modals/confirm/confirm.tpl.html',
          resolve: {
            modalTitle: function () {
              return 'Are you sure?';
            },
            okText: function () {
              return 'Cancel Order';
            },
            modalMessage: function () {
              return 'Do you want to cancel this order?';
            },
          },
        });

        self.cancelModal.result.then(
          function () {
            $scope.$emit('Cart::Close');
            self.cartService.cancelCart().then(self.success.cancel, self.error.cancel);
          },
          function () {
            // Do nothing
          }
        );
      },

      showTicketsTooltip: function () {
        return !$scope.showActions && $scope.cart.events.length;
      },

      hasNewMembership: function () {
        return !!$scope.cart.cartService.memberships.hasNewMembership();
      },

      success: {
        cancel: function (response) {
          const self = $scope.cart;
          self.refresh();
        },
      },

      error: {
        cancel: function (response) {},
      },

      onCartServiceItemCountUpdate: function (n, o) {
        const self = $scope.cart;

        self.hasItems = n;

        if (self.hasItems || n !== o) {
          self.refresh();
        }
      },

      onCartServiceOrganizationUpdate: function (n, o) {
        const self = $scope.cart;
        if (n && n.id) {
          self.tab = 'organization';
          self.organization = CartService.getOrganization();
        }
      },
    };

    $scope.cart.init();
  }

  return {
    restrict: 'A',
    replace: true,
    templateUrl: 'common/directives/cart/cart.tpl.html',
    controllerAs: '$ctrl',
    scope: {
      showActions: '@',
      showCoupons: '<',
      showOrderType: '@',
    },

    link: function ($scope, $element, $attrs) {
      // Modified after controller runs
    },

    controller: CartDirectiveController,
  };
}

export const CartDirectiveModule = angular
  .module('acme.common.directive.cart', [
    'acme.common.service.api',
    CartServiceModule,
    'acme.common.service.order',
    OrderSummaryDirectiveModule,
    OrderContactDirectiveModule,
    OrderCouponsDirectiveModule,
    OrderOrganizationDirectiveModule,
  ])
  .directive('cart', CartDirective).name;
